import React from 'react';
import SuccessPictogram from '@guildeducationinc/recess/pictograms/SuccessPictogram';
import { DatePickerProps, DefaultTheme, Typography } from '@guildeducationinc/recess';
import classnames from 'classnames';
import { FieldInputProps } from 'formik';
import DatePickerField from '@src/components/Shared/FormInputFields/DatePickerField/DatePickerField';
import './CompletionDateField.scss';

export const COMPLETION_DATE_HEADER = 'Congratulations on completing your program!';
export const COMPLETION_DATE_TEXT =
  'Provide the date you completed all requirements for your program, then save it in your completed program history.';

type BaseInputProps = FieldInputProps<string> & DatePickerProps;
type CompletionDateFieldProps = BaseInputProps;

const CompletionDateField: React.FC<CompletionDateFieldProps> = (props) => {
  const completionDateClassNames = classnames([
    'completionDate',
    'boxShadow--lg',
    'margin--top_40',
    'padding--y_24',
    'padding--x_24',
    'flex',
    'flexDirection--column',
    'flexItems--center',
    'lg:padding--right_0',
    'lg:flexDirection--rowReverse',
    'lg:flexJustify--space_between',
  ]);

  const iconClassNames = classnames([
    'successIcon',
    'margin--bottom_16',
    'flex--none',
    'lg:flexSelf--end',
    'lg:margin--bottom_0',
    'lg:margin--left_24',
  ]);

  return (
    <div className={completionDateClassNames}>
      <div className={iconClassNames}>
        <SuccessPictogram size={164} strokeColor={DefaultTheme.iconColor} />
      </div>

      <div className='accountFormFields position--relative'>
        <Typography variant='title2'>{COMPLETION_DATE_HEADER}</Typography>
        <Typography variant='body1' className='padding--top_8 padding--bottom_24'>
          {COMPLETION_DATE_TEXT}
        </Typography>
        <DatePickerField {...props} />
      </div>
    </div>
  );
};

export default CompletionDateField;
